import { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

export function getRouteProperty(
    propertyName = '',
    router: Router,
    activatedRoute: ActivatedRoute
): Signal<boolean> {
    const routeProperty$ = router.events
        .pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => activatedRoute),
            map(route => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter(route => route.outlet === 'primary'),
            mergeMap(route => route.data),
            map(event => event?.[`${propertyName}`] === false ? false : true)
        );

    const defaultValue = propertyName === 'navbar' || propertyName === 'footer' ? false : true;

    return toSignal(routeProperty$, {
        initialValue: defaultValue
    }) as Signal<boolean>;
}
